import { applySheets } from "../../../app/utils/styleCache.js";

export class AppCard extends HTMLElement {
    static get observedAttributes() {
        return ["label", "value", "sub", "accent", "reserve-sub", "warn"];
    }

    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.isMounted = false;
    }

    connectedCallback() {
        this.shadowRoot.innerHTML = `
            <style>
                :host { opacity: 0; }
                :host([loaded]) { opacity: 1; transition: opacity 0.2s ease-in; }
            </style>
            <div class="card">
                <div class="cardLabel"></div>
                <div class="cardValue"></div>
                <div class="cardSub"></div>
            </div>
        `;

        this.isMounted = true;

        applySheets(this.shadowRoot, ["components/shared/app-card/app-card.css"]).then(() => requestAnimationFrame(() => this.setAttribute("loaded", "")));

        this.update();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.isMounted && oldValue !== newValue) {
            this.update();
        }
    }

    update() {
        if (!this.isMounted) return;

        const labelEl = this.shadowRoot.querySelector(".cardLabel");
        const valueEl = this.shadowRoot.querySelector(".cardValue");
        const subEl   = this.shadowRoot.querySelector(".cardSub");

        if (!labelEl || !valueEl || !subEl) return;

        labelEl.textContent = this.getAttribute("label") ?? "";
        valueEl.textContent = this.getAttribute("value") ?? "--";
        subEl.textContent   = this.getAttribute("sub") ?? "";

        valueEl.classList.toggle("accent", this.hasAttribute("accent"));
        subEl.classList.toggle("reserve", this.hasAttribute("reserve-sub"));
        subEl.classList.toggle("warn", this.hasAttribute("warn"));
    }
}

customElements.define("app-card", AppCard);